import { useRef } from 'react'

import { logger } from 'utils/logger'

import { errors } from 'constants/errors'

import { StyledButtonLoadProps, EventButton, EventInput } from './@types'

import { ButtonLoad, InputLoad, Wrapper } from './Style'

const ButtonLoadFile = ({ id, accept, children, transmitData, size = 'default' }: StyledButtonLoadProps) => {
  const fileRef = useRef<HTMLInputElement>(null)

  const selectFile = (event: EventInput) => {
    try {
      const { files } = event.target
      const selectedFiles = files as FileList
      if (!selectedFiles) {
        throw new Error(errors.validation.FILE_IS_REQUIRED)
      }

      transmitData(selectedFiles?.[0])
    } catch (err) {
      logger.error('selectFile', err.message)
      throw err
    }
  }

  const handleClick = (e: EventButton) => {
    e.preventDefault()
    fileRef.current?.click()
  }

  return (
    <Wrapper>
      <label htmlFor={id}>
        <ButtonLoad size={size} transmitData={transmitData} onClick={handleClick}>
          {children}
        </ButtonLoad>
      </label>
      <InputLoad id={id} ref={fileRef} type='file' accept={accept} onChange={selectFile} />
    </Wrapper>
  )
}

export { ButtonLoadFile }
